import Base from './base'

export type AccountStage = {
  id: number
  name: string
  active: boolean
  order: number
}

export default class AccountStages extends Base {
  async get(): Promise<AccountStage[]> {
    try {
      const response = await this.api.get('account_stages.json', {
        params: { per_page: 100, sort_by: 'order', sort_direction: 'ASC' },
      })
      return response.data ?? []
    } catch {
      return []
    }
  }
}
